export default __webpack_public_path__ + "static/video-poster-a49dc0c8c862cd6d6684808a45154927.jpg";